<script setup>
import { onMounted, computed } from "vue";
import { useStore } from "vuex";

const store = useStore();

const latestActionLogs = computed(
  () => store.getters["actionLogs/getLatestLogs"]
);

const isLoading = computed(
  () => store.getters["actionLogs/isLatestLogsLoading"]
);

onMounted(async () => {
  await store.dispatch("actionLogs/fetchLatestActionLogs");
});
</script>

<template>
  <div class="col-6 latest-logs-column">
    <div class="card latest-logs-card">
      <div v-if="isLoading" class="loading-spinner">
        <i class="fas fa-spinner fa-spin"></i>
      </div>
      <div class="card-header">
        <h3 class="card-title">LATEST COURSE ACTIONS:</h3>
      </div>
      <div class="card-body" style="overflow: auto">
        <div class="card">
          <table
            class="table custom-table table-hover"
            id="latest-action-logs-table"
          >
            <thead>
              <tr>
                <th>Course</th>
                <th>Action</th>
                <th>Date</th>
                <th>Time</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="log in latestActionLogs" :key="log.id">
                <td>{{ log.course_name }}</td>
                <td>{{ log.action }}</td>
                <td>{{ log.date }}</td>
                <td>{{ log.time }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-table {
  border-collapse: collapse;
}

.custom-table th,
.custom-table td {
  border-left: none;
  border-right: none;
  border-top: 1px solid #707375;
  border-bottom: 1px solid #77797c;
}

.custom-table thead th {
  border-bottom: 2px solid #87898c;
}

.latest-logs-card {
  height: 458px;
  padding-bottom: 20px;
}

.loading-spinner {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  z-index: 10;
  background: #000000;
  opacity: 0.4;
  font-size: 40px;
}

@media (max-width: 1024px) {
  .latest-logs-card {
    height: auto;
    max-height: 458px;
    padding-bottom: 20px;
  }
  .latest-logs-column {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
</style>
